import { CryptoUtil, convertString2JSON, getDataFromPrefixKey, isExternalLink } from "utils";
import { getInteractor } from "services/local.service";

class BotMessage {
  async botMessageProcess(newMessage, messageOptions, prefixKey) {
    const [_, branchId] = getDataFromPrefixKey(prefixKey);
    const branch = await getInteractor(prefixKey).LocalBranchService.findOne({ id: branchId });
    const branchOptions = branch?.options ? convertString2JSON(branch.options, {}) : {};
    const publicKeyRSA = branchOptions.public_key_rsa;
    const encryptKey = messageOptions.s_key;
    const encryptIv = messageOptions.iv;
    if (false === Boolean(publicKeyRSA && encryptKey && encryptIv))
      return false; // Skip execute message if not enough data to decrypt message;
    else {
      const key = await CryptoUtil.decryptRSA(encryptKey, publicKeyRSA);
      const iv = await CryptoUtil.decryptRSA(encryptIv, publicKeyRSA);

      const decryptContent = await CryptoUtil.decryptCBC_v2(newMessage.content, key, iv);
      if (isExternalLink(decryptContent)) {
        const newMsgOptions = { ...messageOptions, is_link: 1 };
        newMessage.options = JSON.stringify(newMsgOptions);
      }
      newMessage.content = decryptContent;
    }
  }
}

export default BotMessage;
